.group {
  display: flex;
  padding: 0 0.25rem;
}

.btn {
  composes: btn from '../../utils.module.css';
  padding: 0 !important; /* style ordering issue in Storybook */
}

.btnLike {
  composes: btnLike from '../../utils.module.css';
}

.btn:not(:first-child) > .btnLike {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn:not(:last-child) > .btnLike {
  margin-right: -1px; /* attenuate shadow between buttons */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.icon {
  composes: icon from '../../utils.module.css';
}

.label {
  composes: label from '../../utils.module.css';
}

.btn[data-hint] .label {
  position: relative;
  top: 1px;
  border-bottom: 1px dotted currentColor;
  line-height: 1.1;
}
